<onyx-section [heading]="`${I18N}.heading`">
  <onyx-button
    options
    variant="outlined"
    [size]="24"
    leftIcon="add-outlined"
    (click)="addVisa()"
  >
    {{ 'labels.add' | translate }}
  </onyx-button>

  @if (form().controls.length !== 0) {
    <form>
      @for (visaGroup of form().controls; track visaGroup) {
        <ng-container [formGroup]="visaGroup">
          @let controls = visaGroup.controls;
          <div class="group">
            <div class="option">
              <div class="index f-body-l">{{ $index + 1 }}</div>
            </div>

            <onyx-dropdown
              [formControl]="controls.country"
              label="labels.country"
              [options]="countries$ | async"
              [search]="true"
              [size]="32"
            ></onyx-dropdown>
          </div>

          <onyx-datepicker
            [formControl]="controls.expirationDate"
            label="labels.expirationDate"
            [yearsRange]="{ past: 0, future: 10 }"
            [warningTypes]="['pastDate']"
            [size]="32"
          ></onyx-datepicker>

          <div class="scans">
            <onyx-upload
              [formControl]="controls.scans"
              label="labels.visaScan"
              [size]="32"
              [limit]="2"
            ></onyx-upload>

            <onyx-icon-button
              class="option"
              variant="transparent"
              color="black"
              [size]="32"
              icon="delete-outlined"
              (click)="removeVisa($index)"
            ></onyx-icon-button>
          </div>
        </ng-container>
      }
    </form>
  }
</onyx-section>
